import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 14px;

  svg {
    width: 25px;
    height: 25px;
  }

  span {
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 23px;
    text-align: center;
    color: #667085;
  }

  div.container-links {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 14px;
  }

    @media only screen and (max-width: 950px) {
    a {
      svg {
        width: 40px;
      }
    }
  }
`;
